import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import { reactI18nextModule } from 'react-i18next';

import { Constants } from './constants';

// Allows this to work in unit tests
const testReactI18nextModule = require('react-i18next');

export const init = ()=> {
  if(process.env.NODE_ENV === Constants.common.TEST_ENV){
    i18n
    // load translation using xhr -> see /public/locales
    // learn more: https://github.com/i18next/i18next-xhr-backend
    .use(Backend)
    // pass the i18n instance to the react-i18next components.
    // Alternative use the I18nextProvider: https://react.i18next.com/components/i18nextprovider
    .use(testReactI18nextModule)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
      fallbackLng: 'en',
      debug: false,
      interpolation: {
        escapeValue: false
      },
  
      // special options for react-i18next
      // learn more: https://react.i18next.com/components/i18next-instance
      react: {
        wait: true
      }
    });
  } else if(process.env.NODE_ENV === Constants.common.PROD_ENV) {
    i18n
    // load translation using xhr -> see /public/locales
    // learn more: https://github.com/i18next/i18next-xhr-backend
    .use(Backend)
    // pass the i18n instance to the react-i18next components.
    // Alternative use the I18nextProvider: https://react.i18next.com/components/i18nextprovider
    .use(reactI18nextModule)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
      fallbackLng: 'en',
      debug: false,
      interpolation: {
        escapeValue: false, 
      },
  
      // special options for react-i18next
      // learn more: https://react.i18next.com/components/i18next-instance
      react: {
        wait: true
      }
    });
  
  } else {
    i18n
    // load translation using xhr -> see /public/locales
    // learn more: https://github.com/i18next/i18next-xhr-backend
    .use(Backend)
    // pass the i18n instance to the react-i18next components.
    // Alternative use the I18nextProvider: https://react.i18next.com/components/i18nextprovider
    .use(reactI18nextModule)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
      fallbackLng: 'en',
      debug: true,
      interpolation: {
        escapeValue: false, 
      },
  
      // special options for react-i18next
      // learn more: https://react.i18next.com/components/i18next-instance
      react: {
        wait: true
      }
    });
  }

  return i18n;
}


export default init();


// WEBPACK FOOTER //
// ./src/common/i18n.js